import { formatPoints } from 'front-commons/ds/components/FidelityBox/helpers';
import type { TriggerProps } from '../../interfaces';

/**
 * Chooses fidelity entry labels from opt-in, level and current balance.
 *
 * ---
 * 🧠 **Context**
 *
 * - Used by the bottom-row fidelity trigger.
 * - Missing opt-in takes priority over balance; the first opted-in level uses the points invitation.
 *
 * ---
 * @example
 * ```ts
 * const labels = getTriggerLabels({ currentBalance: 1250, level: 2, optIn: true });
 * ```
 *
 * ---
 * @function getTriggerLabels
 * @param {TriggerProps} props - Fidelity membership and balance fields.
 * @returns {ReturnType<typeof getTriggerLabels>} Title and subtitle displayed by the fidelity entry.
 */
export function getTriggerLabels({ currentBalance, level, optIn }: TriggerProps) {
	let title = formatPoints(currentBalance);
	let subtitle = 'pontos';

	if (!optIn) {
		title = 'Fidelidade';
		subtitle = 'Comece agora!';
	}

	if (optIn && level === 1) {
		title = 'Pontue!';
		subtitle = 'veja vantagens';
	}

	return { title, subtitle };
}
